export enum HoverType {
    ALLDAY = 'ALLDAY',
    TASK = 'TASK',
    GENERAL = 'GENERAL',
  }
